<template>
  <div>
    <CRow class="mb-3">
      <div class="col-lg-3 col-md-6 col-sm-6">
        <label class="typo__label font-weight-bold"> Partner </label>
        <multiselect
          v-model="partnerSelected"
          placeholder="Seleccione un Partner"
          label="value"
          track-by="id"
          :options="partners"
          :close-on-select="true"
          :clear-on-select="false"
          :multiple="false"
          :taggable="false"
        ></multiselect>
                  <!-- @input="getfilterPartner()" -->

      </div>

        <div class="col-lg-3 col-md-6 col-sm-6">
          <label class="typo__label font-weight-bold"> Business Unit </label>
          <treeselect
            
            v-model="businessunitSelected"
            :multiple="true"
            :options="businessUnits[0]"
            @input="getfilterbusinessUnit()"
          />
          <!-- :load-options="loadOptions" -->
        </div>
      <CCol class="col-lg-3 col-md-6 col-sm-6">
        <label class="typo__label font-weight-bold"> Star Rating </label>

        <multiselect
          v-model="starratingSelected"
          placeholder="Seleccione un Rating"
          label="label"
          track-by="label"
          :options="starRating_unique"
          @input="getfilterstarRating()"
          :multiple="true"
          :taggable="true"
        ></multiselect>
        <!-- @input="getfilterstarRating()" -->
        <!-- <multiselect
                  v-model="starratingSelected"
                  deselect-label
                  placeholder="Seleccione un Rating"
                  label="label"
                  track-by="label"
                  :options="starRating_unique"
                  :searchable="false"
                  :allow-empty="false"
                ></multiselect> -->
        <!-- @input="onChangeRating()" -->
      </CCol>
      <div class="col-lg-3 col-md-6 col-sm-6">
        <div>
          <label class="typo__label font-weight-bold"> Date Created </label>
        </div>
        <date-picker
          v-model="range"
          range
          :shortcuts="shortcuts"
          confirm
          @change="dateSelected(range)"
        ></date-picker>
      </div>
    </CRow>
    <CRow class="pt-2 pb-3">
      <CCol sm="3">
      </CCol>
    </CRow>
    <CRow>
      <CCol md="6" lg="3">
          <!-- color="primary" -->
        <CWidgetDropdown
          text="graph shows last 7 days avg rating"
          :header="'Avg Rating - ' + widget_rating"
          style="background-color: #7c7c7c;"

        >
          <template #footer>
            <CChartLineSimple
              pointed
              class="mt-3 mx-3"
              style="height: 70px"
              :data-points="widget_weekdata_rating"
              point-hover-background-color="primary"
              label=""
              labels="months1"
            />
          </template>
        </CWidgetDropdown>
      </CCol>
      <CCol md="6" lg="3">
          <!-- color="info" -->
        <CWidgetDropdown
          text="graph shows last 7 days avg reviews"
          :header="'Reviews - ' + widget_review"
          style="background-color: #7c7c7c;"

        >
          <template #footer>
            <CChartLineSimple
              pointed
              class="mt-3 mx-3"
              style="height: 70px"
              :data-points="widget_weekdata_review"
              point-hover-background-color="info"
              :options="{ elements: { line: { tension: 0.00001 } } }"
              label=" "
              labels="months1"
            />
          </template>
        </CWidgetDropdown>
      </CCol>
      <CCol md="6" lg="3">
          <!-- color="warning" -->
        <CWidgetDropdown
          text="graph shows last 7 days avg comments"
          :header="'Comments - ' + widget_comment"
          style="background-color: #7c7c7c;"
          
        >
          <template #footer>
            <CChartLineSimple
              class="mt-3"
              style="height: 70px"
              background-color="rgba(255,255,255,.2)"
              :data-points="widget_weekdata_comment"
              :options="{ elements: { line: { borderWidth: 2.5 } } }"
              point-hover-background-color="warning"
              label=""
              labels="months1"
            />
          </template>
        </CWidgetDropdown>
      </CCol>
      <CCol md="6" lg="3">
          <!-- color="danger" -->
        <CWidgetDropdown
          text="graph shows Monthly Rating"
          :header="'Monthly Rating - ' + widget_rating"
          class="pt-1"
          style="height: 160px; background-color: #7c7c7c;"
        >
          <template #footer>
            <CChartBarSimple
              class="mt-4 mx-3"
              style="height: 70px"
              :data-points="widget_month_data"
              background-color="rgb(250, 152, 152)"
              label=""
              :labels="labelbar"
            />
          </template>
        </CWidgetDropdown>
      </CCol>
    </CRow>
    <!-- 1st  -->
            <CRow class="gridstyle">
          <CCol lg="4" md="12" class=" ">
        <CCard>
          <CCardBody>
             <div v-if="loader_starcommentreview">
                  <semipolar-spinner
                    :animation-duration="2000"
                    :size="80"
                    color="blue"></semipolar-spinner>
              </div>
              <div v-else>
              <CDataTable
                :items="rating_count"
                :fields="fields_count"
                hover
                striped
                bordered
                large
                fixed
                caption="Different Values"
              >
            </CDataTable>
          </div>
          </CCardBody>
            </CCard>
          </CCol>
          <CCol lg="4" md="12">
            <CCard>
          <CCardBody>
             <div v-if="loader_starcommentreview">
                  <semipolar-spinner
                    :animation-duration="2000"
                    :size="80"
                    color="blue"></semipolar-spinner>
              </div>
              
            <div v-else class="barChart">
              <apexchart
                type="bar"
                height="300"
                :options="apex_dataconfig_data1.dataSource.chartOptions"
                :series="apex_dataconfig_data1.dataSource.series"
              ></apexchart>
            </div>
          </CCardBody>
            </CCard>
          </CCol>
          <CCol lg="4" md="12">
              <CCard>
              <CCardBody>

             <div v-if="loader_starcommentreview">
                  <semipolar-spinner
                    :animation-duration="2000"
                    :size="80"
                    color="blue"></semipolar-spinner>
              </div>
              
            <div v-else >
              <CChartPie
                style="height: 250px"
                :datasets="donutDatasets"
                :labels="label_pie_chart"
                :options="{ maintainAspectRatio: false }"
              />
            </div>
            </CCardBody>
          </CCard>
          </CCol>
        </CRow>
    <!-- 2nd -->
    <CCard>
      <CCol class="col-12 p-2">
      <CCol  sm="12"  style="height:500px; overflow-y: auto;">
        <CDataTable
          :items="commenttable_data"
          :fields="fields1"
          hover
          striped
          bordered
          small
          fixed
          column-filter
           sorter
        >
          <!-- caption="Different Values" -->
          <!-- class="elevation-1" -->
          <!-- pagination -->
          <!-- :items-per-page="5" -->
          <template #createTime="{ item }">
            <td>
              {{ item.createTime | formatDate }}
            </td>
          </template>
        </CDataTable>

            <div v-if="loadMore">
              <scroll-loader :loader-method="getcommenttabledata" :loader-enable="loadMore">
                  <semipolar-spinner
                    :animation-duration="2000"
                    :size="30"
                    color="blue"
                  ></semipolar-spinner>
              </scroll-loader> 
            </div>
        <!--                   //:fields="fields_data"
        -->
      </CCol>
      </CCol>
      <!-- <CCol class="col-12 p-3">
          <div class="barChart col-md-12" style="height:200">
            <CChartBar :datasets="barchartDatasets1" :labels="['1', '2', '3','4','5',]" />
          </div>
      </CCol>-->
    </CCard>
    <!-- 3rd -->
    <CCard>
      <CCardTitle class="text-center"
        >Reviews vs comments over the time</CCardTitle
      >
      <CCardTitle class="text-center">Avg. star score over the time</CCardTitle>
      <CRow>
        <CCol class="col-12 p-3">
          <div v-if="loader_reviewsvscommentovertimedata"  class="barChart col-md-12 text-center" >
            <semipolar-spinner
              :animation-duration="2000"
              :size="80"
              color="blue"></semipolar-spinner>
        </div>
        
          <div v-else class="barChart col-md-12">
            <!-- <bar-chart height="300" width="1000" :chart-data="barchartDatacollection"></bar-chart> -->
            <apexchart
              type="bar"
              :options="apex_dataconfig_data2.dataSource.chartOptions"
              :series="apex_dataconfig_data2.dataSource.series"
              height="300"
            ></apexchart>
          </div>
        </CCol>
      </CRow>
    </CCard>
    <!-- 4th -->
      <CRow>
        <CCol lg="6" md="12">
        <CCard>
          <CCardTitle class="text-center">-Avg stars</CCardTitle>
          <!-- <CCol sm="12"> -->
            <div v-if="loader_avgstarday"  class="col-md-12 text-center" >
            <semipolar-spinner
              :animation-duration="2000"
              :size="80"
              color="blue"></semipolar-spinner>
            </div>
            <div v-else id="chart-container">
              <apexchart
                type="line"
                height="400"
                :options="apex_dataconfig_data3.dataSource.chartOptions"
                :series="apex_dataconfig_data3.dataSource.series"
              ></apexchart>
            </div>
          <!-- </CCol> -->
        </CCard>
        </CCol>
        <CCol  lg="6" md="12">
          <CCard>
          <CCardTitle class="text-center">-Avg stars</CCardTitle>
          <!-- <CCol sm="12"> -->
            <div v-if="loader_avgstarmonth"  class="col-md-12 text-center" >
            <semipolar-spinner
              :animation-duration="2000"
              :size="80"
              color="blue"></semipolar-spinner>
            </div>
            <div v-else id="chart-container">
              <apexchart
                type="line"
                height="400"
                :options="apex_dataconfig_data.dataSource.chartOptions"
                :series="apex_dataconfig_data.dataSource.series"
              ></apexchart>
            </div>
          <!-- </CCol> -->
        </CCard>
        </CCol>
      </CRow>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import store from "../store";
import MainChartExample from "./charts/MainChartExample";
import WidgetsDropdown from "./widgets/WidgetsDropdown";
import WidgetsBrand from "./widgets/WidgetsBrand";
import { CChartLineSimple, CChartBarSimple } from "./charts/index.js";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/scss/index.scss";
import { CChartDoughnut, CChartPie, CChartBar } from "@coreui/vue-chartjs";
import BarChart from "./pages/Barchart.js";
import VueFusionCharts from "vue-fusioncharts";
import Charts from "fusioncharts/fusioncharts.charts";
import FusionCharts from "fusioncharts";
import Column2D from "fusioncharts/fusioncharts.charts";
import FusionTheme from "fusioncharts/themes/fusioncharts.theme.fusion";
import { FCComponent } from "vue-fusioncharts";
import VueApexCharts from "vue-apexcharts";
import { shuffleArray } from "@/shared/utils";
import { SemipolarSpinner } from "epic-spinners";
import moment from "moment";
import _ from 'lodash';

import { LOAD_CHILDREN_OPTIONS } from "@riophae/vue-treeselect";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ScrollLoader from "vue-scroll-loader";

Charts(FusionCharts);
// Preparing the chart data
const apex_data = {
  series: [
    {
      name: "Money",
      data: [4.5, 4.65, 4.3, 3.8, 2.3, 3.2, 4.8, 5.6, 3.4],
    },
  ],
  chartOptions: {
    chart: {
      type: "bar",
      height: 300,
      stacked: true,
      toolbar: {
        show: true,
      },
      zoom: {
        enabled: true,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: "bottom",
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    xaxis: {
      type: "String",
      categories: [
        "Jan 2019",
        "Feb 2019",
        "Mar 2019",
        "Apr 2019",
        "May 2019",
        "June 2019",
        "July 2019",
        "AUG 2019",
        "Sep 2019",
        "Oct 2019",
        "Nov 2019",
        "Dec 2019",
        "Jan 2020",
        "Feb 2020",
        "Mar 2020",
      ],
    },
    legend: {
      position: "top",
      offsetY: 40,
    },
    fill: {
      opacity: 1,
    },
  },
};

export default {
  name: "Dashboard",
  components: {
    DatePicker,
    CChartLineSimple,
    CChartBarSimple,

    MainChartExample,
    WidgetsDropdown,
    WidgetsBrand,
    CChartDoughnut,
    CChartPie,
    CChartBar,
    BarChart,
    SemipolarSpinner,
    Multiselect,
    apexchart: VueApexCharts,
    Treeselect,
  },
  async mounted() {
    var respuesta = await this.getPartners();
    // await this.getGbaReviews();

    // await this.getlocation();
    // this.barchartdata();
    // this.barchartdata1();
    // this.apex_dataConfig();
    // this.apex_dataConfig1();
    // this.apex_dataConfig2();
    // this.apexdata3();
    // this.getLast7DaysData(this.global_gbaReviews);
    // this.getLast30DaysData(this.global_gbaReviews);
  },
  data() {
    var today = new Date();
    var yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    var last7days = new Date(today);
    last7days.setDate(last7days.getDate() - 6);
    var lastmonth = new Date(today);
    lastmonth.setMonth(lastmonth.getMonth() - 1);

    return {
      demographicExcludeSelected: [],
      countriesIncludes: [
        {
          name: "Spain",
          id: 68,
          label: "Spain",
          code: "ES",
          children: null,
        },
      ],
      widget_review: 0,
      widget_comment: 0,
      widget_rating: 0,
      widget_month_rating: 0,

      widget_review_partner: 0,
      widget_comment_partner: 0,
      widget_rating_partner: 0,
      widget_month_rating_partner: 0,

      commenttable_data: [],
      commenttable_data_partner: [],
      loadMore: false,
      offset_insight: 0,

      // widget_monthlyRating: "0",
      // widget_reviews: 0,
      // widget_comments: 0,
      // widget_rating: 0,

      widget_month_data: [],
      widget_weekdata: [],

      widget_weekdata_rating: [],
      widget_weekdata_comment: [],
      widget_weekdata_review: [],
      widget_reviews: [],
      widget_comments: [],
      widget_rating: [],

      labelbar: [],

      tableData: [],
      fields: [
        { key: "rating", label: "Star Rating", sortable: true },
        { key: "reviews", label: "Reviews", sortable: true },
        { key: "comments", label: "Comment", sortable: true },
      ],
      fields_count: [
        { key: "starRating", label: "Star Rating", sortable: true },
        { key: "review_count", label: "Reviews", sortable: true },
        { key: "comment_count", label: "Comment", sortable: true },
      ],
      fields1: [
        { key: "createTime", label: "Date", sortable: true },
        { key: "comment", label: "Orignal Comments", sortable: true },
        {
          key: "comment_eng",
          label: "Google translated comment",
          sortable: true,
        },
      ],
      valueData: [],
      tempValueData: [],
      date: "",
      time: "",
      range: "",
      // partnersSelected: "Aire Ancient Baths ES",
      // partners: ["Aire Ancient Baths ES"],
      partnersArray: [],

      partners: [],
      partnersArray: [],
      partnerSelected: "",
      partner_ids: [],
      locations: [],
      locations1: [[]],
      businessUnits: [[]],
      businessunitSelected: [],

      locationsArray: [],
      locationSelected: [],
      locationSelected1: "",

      starRating: [],
      isLoading: false,
      loader_starcommentreview: false,
      loader_commenttable_data: false,
      loader_reviewsvscommentovertimedata: false,
      loader_avgstarday: false,
      loader_avgstarmonth: false,

      starRating_unique: [
        { label: 1, value: 1 },
        { label: 2, value: 2 },
        { label: 3, value: 3 },
        { label: 4, value: 4 },
        { label: 5, value: 5 },
      ],
      starratingSelected: "",
      createTimeFilter: [],
      searchLocation: [],
      shortcuts: [
        {
          text: "Today",
          onClick: () => {
            this.range = [today, today];
          },
        },
        {
          text: "YesterDay",
          onClick: () => {
            this.range = [yesterday, yesterday];
          },
        },
        {
          text: "Last 7 Days",
          onClick: () => {
            this.range = [last7days, last7days];
          },
        },
        {
          text: "Last Month",
          onClick: () => {
            this.range = [lastmonth, lastmonth];
          },
        },
      ],
      timePickerOptions: {
        start: "00:00",
        step: "00:30",
        end: "23:30",
      },
      // userscomments: [
      //   {
      //     Date: "mar 11, 2020",
      //     Original_Comments: "Google_Translated_Comments",
      //     Google_Translated_Comments:
      //       "el sitio muy bonito, los baños, los masajes, el personal todo perfecto. inolvidable el baño desde la azotea con vista à la giralda!!",
      //   },
      //   {
      //     Date: "mar 11, 2020",
      //     Original_Comments:
      //       "A faire ,J ai tout apprécié, les différents bains ,le massage ,les boissons mis à disposition ,l attention dans les vestiaires avec les produits de la marque Dove, et le clou du spectacle la terrasse en haut du spa ,on peut y voir tous les monuments de Séville allongée dans la piscine chauffée !!!!!MAGNIFIQUE.",
      //     Google_Translated_Comments:
      //       "el sitio muy bonito, los baños, los masajes, el personal todo perfecto. inolvidable el baño desde la azotea con vista à la giralda!!",
      //   },
      //   {
      //     Date: "mar 11, 2020",
      //     Original_Comments:
      //       "el sitio muy bonito, los baños, los masajes, el personal todo perfecto. inolvidable el baño desde la azotea con vista à la giralda!!",
      //     Google_Translated_Comments:
      //       "el sitio muy bonito, los baños, los masajes, el personal todo perfecto. inolvidable el baño desde la azotea con vista à la giralda!!",
      //   },
      //   {
      //     Date: "mar 11, 2020",
      //     Original_Comments:
      //       "el sitio muy bonito, los baños, los masajes, el personal todo perfecto. inolvidable el baño desde la azotea con vista à la giralda!!",
      //     Google_Translated_Comments:
      //       "el sitio muy bonito, los baños, los masajes, el personal todo perfecto. inolvidable el baño desde la azotea con vista à la giralda!!",
      //   },
      //   {
      //     Date: "mar 11, 2020",
      //     Original_Comments:
      //       "el sitio muy bonito, los baños, los masajes, el personal todo perfecto. inolvidable el baño desde la azotea con vista à la giralda!!",
      //     Google_Translated_Comments:
      //       "el sitio muy bonito, los baños, los masajes, el personal todo perfecto. inolvidable el baño desde la azotea con vista à la giralda!!",
      //   },
      // ],
      barchartDatacollection: { labels: [], datasets: [], options: {} },
      apex_dataconfig_data: {
        dataSource: {
          chartOptions: {
            chart: {
              type: "line",
              id: "basic-bar",
            },
          },
        },
      },
      apex_dataconfig_data1: {
        dataSource: {
          chartOptions: {
            chart: {
              type: "bar",
              id: "basic-bar",
            },
          },
        },
      },
      apex_dataconfig_data2: {
        dataSource: {
          chartOptions: {
            chart: {
              type: "bar",
              id: "basic-bar",
            },
          },
        },
      },
      apex_dataconfig_data3: {
        dataSource: {
          chartOptions: {
            chart: {
              type: "line",
              id: "basic-bar",
            },
          },
        },
      },
      abcRating: [],
      abcReviews: [],
      abcComments: [],
      searchLocationId: [],
      global_yearlyReviews: [],
      global_gbaReviews: [],
      global_gbaReviewsArray: [],
      global_gbaReviewsLocation: [],
      selectedpartner: "Aire Ancient Baths ES",
      selectedrating: "1",
      selectedlocation: "",
      selectedTime: "",
      apexdata_label: [],
      apexdata_label_days: [],
      rating_count: [],
      rating_count_piechart: [],
    };
  },
  computed: {
    computedItems() {
      return global_gbaReviews.map((item) => {
        return {
          ...item,
          createTime: item.createTime,
          // registeredDate: item.registered.date
        };
      });
    },
    label_pie_chart() {
      return this.rating_count_piechart.map((item) => {
        return item.starRating;
      });
    },
    donutDatasets() {
      var data1 = this.rating_count_piechart;
      // //console.log("data1:::::::::::", data1);
      var ratings = [];
      var comment_count = [];
      var review_count = [];
      data1.forEach((t) => {
        review_count.push(t.review_count);
      });
      //[ "#00D8FF", "#00L8FF", "#DD1B16", "#E46651", "#E0F7FA", "#00C8FF", ],
      return [
        {
          backgroundColor: [
            "#5700ff",
            "#eeff41",
            "#3d3d3d",
            "#7c7c7c",
            "#b08fff",
            "#D3C5FF",
            "#FAFF99",
            "#CCCCCC",
          ],
          data: review_count, //data.reviews,
          legend: {
            position: "right",
            show: true,
          },
        },
      ];
    },
  },
  methods: {
    getfilterPartner() {
      //console.log("this.partnerSelected ::::: ", this.partnerSelected);
      var partner_names = [];
      this.partnerSelected.forEach((partner) => {
        partner_names.push(partner.name);
      });

      if (this.partnerSelected.length > 0) {
        //console.log("this.partnerSelected ::::: ", this.partnerSelected);

        var gbareview = this.global_gbaReviewsArray;
        // //console.log("gbareview ::: ",this.global_gbaReviewsArray.length);
        var filtered_data_review = gbareview.filter((item, index) => {
          if (item.location_id.partner_id !== undefined) {
            return partner_names.includes(item.location_id.partner_id.name);
          }
        });
        this.global_gbaReviews = filtered_data_review;
        //console.log("gbareview after filter:::if ", filtered_data_review);
        this.getreview_Count(filtered_data_review);
        this.apex_dataConfig1(filtered_data_review);
        this.getreview_CountMonth(filtered_data_review);
        this.getreview_Countquarter(filtered_data_review);
      } else {
        // //console.log("this.partnerSelected None::::: ");
        this.global_gbaReviews = this.global_gbaReviewsArray;
        //console.log("gbareview after filter:::else ", filtered_data_review);
        this.getreview_Count(this.global_gbaReviews);
        this.apex_dataConfig1(this.global_gbaReviews);
        this.getreview_CountMonth(this.global_gbaReviews);
        this.getreview_Countquarter(this.global_gbaReviews);
      }
    },

    getfilterbusinessUnit() {
      var businessUnits = [];
      this.offset_insight = 0;
      // this.businessunitSelected = [];
      //   this.businessUnits=[[]];
      this.offset_insight = 0;
      this.commenttable_data = [];
      this.commenttable_data_partner = [];

      this.widget_rating = 0;
      this.widget_comment = 0;
      this.widget_review = 0;
      this.widget_month_rating = 0;
      this.rating_count = [];
      this.rating_count_piechart = [];
      // this.starRating_unique=[];
      this.commenttable_data = [];
      this.commenttable_data_partner = [];

      this.apex_dataconfig_data = {
        dataSource: {
          chartOptions: {
            chart: {
              type: "line",
              id: "basic-bar",
            },
          },
        },
      };
      this.apex_dataconfig_data1 = {
        dataSource: {
          chartOptions: {
            chart: {
              type: "bar",
              id: "basic-bar",
            },
          },
        },
      };
      this.apex_dataconfig_data2 = {
        dataSource: {
          chartOptions: {
            chart: {
              type: "bar",
              id: "basic-bar",
            },
          },
        },
      };
      this.apex_dataconfig_data3 = {
        dataSource: {
          chartOptions: {
            chart: {
              type: "line",
              id: "basic-bar",
            },
          },
        },
      };
      this.locations = [];
      this.locations1 = [[]];
      this.locationsArray = [];

      this.businessunitSelected.forEach((bu) => {
        businessUnits.push(bu.name);
      });

      //console.log( "selected businessUnits length==>",   this.businessunitSelected    );
      if (this.businessunitSelected.length > 0) {
        if (this.partner_ids[0] == this.businessunitSelected[0]) {
          this.get7daysavgRating();
          this.get7dayscomments();
          this.get7monthsavgRating();
          this.getreviewsandcommentgraphdata();
          this.getstarratingpiechartdata();
          this.getcommenttabledata();
          this.getreviewsvscommentovertime();
          this.getavgstarratingperday();
          this.getavgstarratingpermonth();
        } else {
          this.get7daysavgRating();
          this.get7dayscomments();
          this.get7monthsavgRating();
          this.getreviewsandcommentgraphdata();
          this.getstarratingpiechartdata();
          this.getcommenttabledata();
          this.getreviewsvscommentovertime();
          this.getavgstarratingperday();
          this.getavgstarratingpermonth();
        }
      } else {
        if (this.partner_ids.length > 0) {
          this.get7daysavgRating();
          this.get7dayscomments();
          this.get7monthsavgRating();
          this.getreviewsandcommentgraphdata();
          this.getstarratingpiechartdata();
          this.getcommenttabledata();
          this.getreviewsvscommentovertime();
          this.getavgstarratingperday();
          this.getavgstarratingpermonth();
        } else {
          this.widget_rating = 0;
          this.widget_comment = 0;
          this.widget_review = 0;
          this.widget_month_rating = 0;
          this.rating_count = [];
          this.rating_count_piechart = [];
          this.starRating_unique = [];
          this.commenttable_data = [];

          this.apex_dataconfig_data = {
            dataSource: {
              chartOptions: {
                chart: {
                  type: "line",
                  id: "basic-bar",
                },
              },
            },
          };
          this.apex_dataconfig_data1 = {
            dataSource: {
              chartOptions: {
                chart: {
                  type: "bar",
                  id: "basic-bar",
                },
              },
            },
          };
          this.apex_dataconfig_data2 = {
            dataSource: {
              chartOptions: {
                chart: {
                  type: "bar",
                  id: "basic-bar",
                },
              },
            },
          };
          this.apex_dataconfig_data3 = {
            dataSource: {
              chartOptions: {
                chart: {
                  type: "line",
                  id: "basic-bar",
                },
              },
            },
          };
        }
      }
    },
    getfilterstarRating() {
      var starRatings = [];
      this.offset_insight = 0;
      this.commenttable_data = [];
      this.commenttable_data_partner = [];
      this.starratingSelected.forEach((rating) => {
        starRatings.push(rating.value);
      });
      //console.log("selectede ==>", this.starratingSelected, starRatings);
      if (this.starratingSelected.length > 0) {
        // this.get7daysavgRating();
        // //console.log("before filter  starratingSelected", comment_data.length);
        // var gbareview = [];
        //console.log("this.partnerSelected.length", this.locationSelected);
        if (this.businessunitSelected.length > 0) {
          if (this.partner_ids[0] == this.businessunitSelected[0]) {
            // this.getlocation();
            this.get7daysavgRating();
            this.get7dayscomments();
            this.get7monthsavgRating();
            this.getreviewsandcommentgraphdata();
            this.getstarratingpiechartdata();
            this.getcommenttabledata();
            this.getreviewsvscommentovertime();
            this.getavgstarratingperday();
            this.getavgstarratingpermonth();
          } else {
            this.get7daysavgRating();
            this.get7dayscomments();
            this.get7monthsavgRating();
            this.getreviewsandcommentgraphdata();
            this.getstarratingpiechartdata();
            this.getcommenttabledata();
            this.getreviewsvscommentovertime();
            this.getavgstarratingperday();
            this.getavgstarratingpermonth();
          }
        } else if (this.partner_ids.length > 0) {
          this.get7daysavgRating();
          this.get7dayscomments();
          this.get7monthsavgRating();
          this.getreviewsandcommentgraphdata();
          this.getstarratingpiechartdata();
          this.getcommenttabledata();
          this.getreviewsvscommentovertime();
          this.getavgstarratingperday();
          this.getavgstarratingpermonth();
          // gbareview = this.global_gbaReviews;
          //console.log("starRating==>", this.starratingSelected);
        } else {
        }
      } else {
        // //console.log("this.starratingSelected None::::: ");
        if (this.businessunitSelected.length > 0) {
          if (this.partner_ids[0] == this.businessunitSelected[0]) {
            this.get7daysavgRating();
            this.get7dayscomments();
            this.get7monthsavgRating();
            this.getreviewsandcommentgraphdata();
            this.getstarratingpiechartdata();
            this.getcommenttabledata();
            this.getreviewsvscommentovertime();
            this.getavgstarratingperday();
            this.getavgstarratingpermonth();
          } else {
            this.get7daysavgRating();
            this.get7dayscomments();
            this.get7monthsavgRating();
            this.getreviewsandcommentgraphdata();
            this.getstarratingpiechartdata();
            this.getcommenttabledata();
            this.getreviewsvscommentovertime();
            this.getavgstarratingperday();
            this.getavgstarratingpermonth();
            // this.get7daysavgRatingbyLocation();
            // this.get7dayscommentsbyLocation();
            // this.get7monthsavgRatingbyLocation();
            // this.getreviewsandcommentgraphdatabyLocation();
            // this.getstarratingpiechartdatabyLocation();
            // this.getcommenttabledatabyLocation();
            // this.getreviewsvscommentovertimebyLocation();
            // this.getavgstarratingperdaybyLocation();
            // this.getavgstarratingpermonthbyLocation();
          }
        } else if (this.partner_ids.length > 0) {
          this.get7daysavgRating();
          this.get7dayscomments();
          this.get7monthsavgRating();
          this.getreviewsandcommentgraphdata();
          this.getstarratingpiechartdata();
          this.getcommenttabledata();
          this.getreviewsvscommentovertime();
          this.getavgstarratingperday();
          this.getavgstarratingpermonth();

          // this.global_gbaReviews = this.global_gbaReviews;
          // //console.log("this gbareview data from starRating==>", gbareview);
        } else {
          this.widget_rating = 0;
          this.widget_comment = 0;
          this.widget_review = 0;
          this.widget_month_rating = 0;
          this.rating_count = [];
          this.rating_count_piechart = [];
          this.starRating_unique = [];
          this.commenttable_data = [];

          this.apex_dataconfig_data = {
            dataSource: {
              chartOptions: {
                chart: {
                  type: "line",
                  id: "basic-bar",
                },
              },
            },
          };
          this.apex_dataconfig_data1 = {
            dataSource: {
              chartOptions: {
                chart: {
                  type: "bar",
                  id: "basic-bar",
                },
              },
            },
          };
          this.apex_dataconfig_data2 = {
            dataSource: {
              chartOptions: {
                chart: {
                  type: "bar",
                  id: "basic-bar",
                },
              },
            },
          };
          this.apex_dataconfig_data3 = {
            dataSource: {
              chartOptions: {
                chart: {
                  type: "line",
                  id: "basic-bar",
                },
              },
            },
          };
        }
      }
    },
    dateSelected(date) {
      this.offset_insight = 0;
      this.commenttable_data = [];
      this.commenttable_data_partner = [];

      if (this.range[0] !== null || this.range[0] !== null) {
        // //console.log("In date filer========= ", date , moment(this.range[0]).format('YYYY-MM-DD'),moment(date[1]).format('YYYY-MM-DD'));
        var start = this.range[0];
        var end = this.range[1];
        //console.log(this.partnerSelected.length);
        if (this.businessunitSelected.length > 0) {
          if (this.partner_ids[0] == this.businessunitSelected[0]) {
            // this.getlocation();
            this.get7daysavgRating();
            this.get7dayscomments();
            this.get7monthsavgRating();
            this.getreviewsandcommentgraphdata();
            this.getstarratingpiechartdata();
            this.getcommenttabledata();
            this.getreviewsvscommentovertime();
            this.getavgstarratingperday();
            this.getavgstarratingpermonth();
          } else {
            this.get7daysavgRating();
            this.get7dayscomments();
            this.get7monthsavgRating();
            this.getreviewsandcommentgraphdata();
            this.getstarratingpiechartdata();
            this.getcommenttabledata();
            this.getreviewsvscommentovertime();
            this.getavgstarratingperday();
            this.getavgstarratingpermonth();
            // this.get7daysavgRatingbyLocation();
            // this.get7dayscommentsbyLocation();
            // this.get7monthsavgRatingbyLocation();
            // this.getreviewsandcommentgraphdatabyLocation();
            // this.getstarratingpiechartdatabyLocation();
            // this.getcommenttabledatabyLocation();
            // this.getreviewsvscommentovertimebyLocation();
            // this.getavgstarratingperdaybyLocation();
            // this.getavgstarratingpermonthbyLocation();
          }
        } else if (this.partner_ids.length > 0) {
          this.get7dayscomments();
          this.get7monthsavgRating();
          this.getreviewsandcommentgraphdata();
          this.getstarratingpiechartdata();
          this.getcommenttabledata();
          this.getreviewsvscommentovertime();
          this.getavgstarratingperday();
          this.getavgstarratingpermonth();
        } else {
          this.get7dayscomments();
          this.get7monthsavgRating();
          this.getreviewsandcommentgraphdata();
          this.getstarratingpiechartdata();
          this.getcommenttabledata();
          this.getreviewsvscommentovertime();
          this.getavgstarratingperday();
          this.getavgstarratingpermonth();
        }
      } else {
        if (this.businessunitSelected.length > 0) {
          if (this.partner_ids[0] == this.businessunitSelected[0]) {
            this.get7daysavgRating();
            this.get7dayscomments();
            this.get7monthsavgRating();
            this.getreviewsandcommentgraphdata();
            this.getstarratingpiechartdata();
            this.getcommenttabledata();
            this.getreviewsvscommentovertime();
            this.getavgstarratingperday();
            this.getavgstarratingpermonth();
          } else {
            this.get7daysavgRating();
            this.get7dayscomments();
            this.get7monthsavgRating();
            this.getreviewsandcommentgraphdata();
            this.getstarratingpiechartdata();
            this.getcommenttabledata();
            this.getreviewsvscommentovertime();
            this.getavgstarratingperday();
            this.getavgstarratingpermonth();
            // this.get7daysavgRatingbyLocation();
            // this.get7dayscommentsbyLocation();
            // this.get7monthsavgRatingbyLocation();
            // this.getreviewsandcommentgraphdatabyLocation();
            // this.getstarratingpiechartdatabyLocation();
            // this.getcommenttabledatabyLocation();
            // this.getreviewsvscommentovertimebyLocation();
            // this.getavgstarratingperdaybyLocation();
            // this.getavgstarratingpermonthbyLocation();
          }
        }
        if (this.partner_ids.length > 0) {
          // this.getlocation();
          this.get7daysavgRating();
          this.get7dayscomments();
          this.get7monthsavgRating();
          this.getreviewsandcommentgraphdata();
          this.getstarratingpiechartdata();
          this.getcommenttabledata();
          this.getreviewsvscommentovertime();
          this.getavgstarratingperday();
          this.getavgstarratingpermonth();
        } else {
          this.widget_rating = 0;
          this.widget_comment = 0;
          this.widget_review = 0;
          this.widget_month_rating = 0;
          this.rating_count = [];
          this.rating_count_piechart = [];
          this.starRating_unique = [];
          this.commenttable_data = [];

          this.apex_dataconfig_data = {
            dataSource: {
              chartOptions: {
                chart: {
                  type: "line",
                  id: "basic-bar",
                },
              },
            },
          };
          this.apex_dataconfig_data1 = {
            dataSource: {
              chartOptions: {
                chart: {
                  type: "bar",
                  id: "basic-bar",
                },
              },
            },
          };
          this.apex_dataconfig_data2 = {
            dataSource: {
              chartOptions: {
                chart: {
                  type: "bar",
                  id: "basic-bar",
                },
              },
            },
          };
          this.apex_dataconfig_data3 = {
            dataSource: {
              chartOptions: {
                chart: {
                  type: "line",
                  id: "basic-bar",
                },
              },
            },
          };
        }
      }
    },
    getlocation1() {
      var gbalocation = store.getters.getlocation;
      // //console.log("partner_ids", this.partner_ids);
      // //console.log( "item location1111 ::::::===>", gbalocation.length, this.isLoading );

      if (gbalocation.length == 0) {
        this.isLoading = true;
        var partner_ids = this.partner_ids;
        store.dispatch("getlocation").then(() => {
          gbalocation = store.getters.getlocation;
          ////console.log("gbalocation", gbalocation);

          var locationsByPartner = [];
          gbalocation.map((location) => {
            ////console.log("location.partner_id.id == partner_ids:::",location.partner_id.id , partner_ids);
            // if (location.partner_id.id == partner_ids) {
            if (partner_ids.includes(location.partner_id.id)) {
              locationsByPartner.push(location);
            }
          });
          ////console.log("locationsByPartner", locationsByPartner);
          this.isLoading = false;
          const locationunique = [
            ...new Map(
              locationsByPartner.map((item) => [item["locationName"], item])
            ).values(),
          ];

          this.locations = _.sortBy(locationunique, "locationName");
          ////console.log("item location@@@: :::::===>", this.locations);
        });
      } else {
        this.isLoading = false;
        var partner_ids = this.partner_ids;
        var locationsByPartner = [];
        gbalocation.map((location) => {
          // //console.log("location.partner_id.id == partner_ids: else ::",location.partner_id.id , partner_ids);

          if (partner_ids.includes(location.partner_id.id)) {
            locationsByPartner.push(location);
          }
        });

        const locationunique = [
          ...new Map(
            locationsByPartner.map((item) => [item["locationName"], item])
          ).values(),
        ];

        this.locations = _.sortBy(locationunique, "locationName");
        this.locationsArray = _.sortBy(locationunique, "locationName");
      }
    },
    customLabel({ locationName, city, description }) {
      return `${locationName} – ${city} – ${description}`;
    },

    async get7daysavgRating() {
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];

      var partner_ids = this.partner_ids;

      if (this.businessunitSelected.length > 0) {
        this.businessunitSelected.forEach((bu) => {
          business_unit_ids.push(bu);
        });
      }
      // //console.log("this.locationSelected , location_ids ::: ", this.locationSelected , location_ids);
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      //console.log(    "selected ==>",   this.starratingSelected,    starRatings,     this.range    );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "business_unit",
      };

      await store.dispatch("get7daysavgRating", payload).then(() => {
        var avgRating = store.getters.get7daysavgRating;
        //console.log( "avgRating get7daysavgRating::: ", avgRating,   store.getters.get7daysavgRating   );
        var review_count = 0;
        var starRating = 0;
        var count = 0;
        if (avgRating.length > 0) {
          avgRating.forEach((reviews) => {
            //console.log("reviews in 7 days avg::::", reviews);
            count = count + 1;
            review_count = review_count + reviews.__count;
            starRating = starRating + reviews.starRating_avg;
          });
          this.widget_rating = (starRating / count).toFixed(2);
          this.widget_review = review_count;
          this.widget_rating_partner = (starRating / count).toFixed(2);
          this.widget_review_partner = review_count;
        } else {
          this.widget_rating = 0;
          this.widget_review = 0;
        }
        return;
      });
    },
    async get7monthsavgRating() {
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];

      var partner_ids = this.partner_ids;

      if (this.businessunitSelected.length > 0) {
        this.businessunitSelected.forEach((bu) => {
          business_unit_ids.push(bu);
        });
      }
      // if(this.locationSelected.length > 0){
      //   this.locationSelected.forEach((location) => {
      //     location_ids.push(location);
      //   });
      // }
      // //console.log("this.locationSelected , location_ids ::: ", this.locationSelected , location_ids);
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      //console.log(  "selected ==>", this.starratingSelected,    starRatings,   this.range    );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "business_unit",
      };

      await store.dispatch("get7monthsavgRating", payload).then(() => {
        var monthavgRating = store.getters.get7monthsavgRating;
        //console.log("monthavgRating get7daysavgRating::: ", monthavgRating);
        var review_count = 0;
        var starRating = 0;
        var count = 0;
        if (monthavgRating.length > 0) {
          monthavgRating.forEach((reviews) => {
            //console.log("reviews in 7 days avg::::", reviews);
            count = count + 1;
            // review_count = review_count + reviews.__count;
            starRating = starRating + reviews.starRating_avg;
          });

          this.widget_month_rating = (starRating / count).toFixed(2);
          this.widget_month_rating_partner = (starRating / count).toFixed(2);
        } else {
          this.widget_month_rating = 0;
        }
        return;
      });
    },
    async get7dayscomments() {
      var widget_comments = 0;
      // var partner_ids = this.partner_ids;
      var avgComments = 0;
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];

      var partner_ids = this.partner_ids;

      if (this.businessunitSelected.length > 0) {
        this.businessunitSelected.forEach((bu) => {
          business_unit_ids.push(bu);
        });
      }
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      //console.log( "selected ==>",  this.starratingSelected,    starRatings,     this.range  );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "business_unit",
      };
      await store.dispatch("get7dayscomments", payload).then(() => {
        //console.log( "avgRating get7dayscomments::: ", store.getters.get7dayscomments  );
        var avgComments = store.getters.get7dayscomments;

        this.widget_comment = avgComments;
        this.widget_comment_partner = avgComments;
        return;
      });
    },
    async getreviewsandcommentgraphdata() {
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];

      var partner_ids = this.partner_ids;

      if (this.businessunitSelected.length > 0) {
        this.businessunitSelected.forEach((bu) => {
          business_unit_ids.push(bu);
        });
      }
      // if(this.locationSelected.length > 0){
      //   this.locationSelected.forEach((location) => {
      //     location_ids.push(location);
      //   });
      // }
      // //console.log("this.locationSelected , location_ids ::: ", this.locationSelected , location_ids);
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      //console.log(  "selected ==>", this.starratingSelected,  starRatings, this.range  );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "business_unit",
      };
      this.loader_starcommentreview = true;
      await store
        .dispatch("getreviewsandcommentgraphdata", payload)
        .then(() => {
          var reviewsandcommentgraphdata =
            store.getters.getreviewsandcommentgraphdata;
          //console.log(    "reviewsandcommentgraphdata::: ",   reviewsandcommentgraphdata  );
          var count = 0;
          var starRating = [];
          var reviews = [];
          var comment = [];
          var comment_count = 0;
          var reviewsandcomment = [];
          this.reviewsandcommentgraphdata_partner = reviewsandcommentgraphdata;
          if (reviewsandcommentgraphdata.length > 0) {
            this.getreview_Count(reviewsandcommentgraphdata);
            this.apex_dataConfig1(reviewsandcommentgraphdata);
          } else {
            this.rating_count = [];

            this.apex_dataconfig_data1 = {
              dataSource: {
                chartOptions: {
                  chart: {
                    type: "bar",
                    id: "basic-bar",
                  },
                },
              },
            };
          }
          this.loader_starcommentreview = false;
          return;
        });
    },
    async getstarratingpiechartdata() {
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];

      var partner_ids = this.partner_ids;

      if (this.businessunitSelected.length > 0) {
        this.businessunitSelected.forEach((bu) => {
          business_unit_ids.push(bu);
        });
      }
      // if(this.locationSelected.length > 0){
      //   this.locationSelected.forEach((location) => {
      //     location_ids.push(location);
      //   });
      // }
      // //console.log("this.locationSelected , location_ids ::: ", this.locationSelected , location_ids);
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      //console.log(  "selected ==>",   this.starratingSelected,   starRatings,    this.range  );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "business_unit",
      };
      this.loader_starcommentreview = true;

      await store.dispatch("getstarratingpiechartdata", payload).then(() => {
        var starratingpiechartdata = store.getters.getstarratingpiechartdata;
        //console.log("starratingpiechartdata::: ", starratingpiechartdata);
        var count = 0;
        // this.starratingpiechartdata_partner = starratingpiechartdata;
        if (starratingpiechartdata.length > 0) {
          this.getstarrating_Count(starratingpiechartdata);
        } else {
          this.rating_count_piechart = [];
        }
        this.loader_starcommentreview = false;

        return;
      });
    },
    async getcommenttabledata() {
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];

      var partner_ids = this.partner_ids;

      if (this.businessunitSelected.length > 0) {
        this.businessunitSelected.forEach((bu) => {
          business_unit_ids.push(bu);
        });
      }
      // if(this.locationSelected.length > 0){
      //   this.locationSelected.forEach((location) => {
      //     location_ids.push(location);
      //   });
      // }
      //console.log( "this.businessunitSelected , location_ids ::: ", this.businessunitSelected,  business_unit_ids   );
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      //console.log( "selected ==>",  this.starratingSelected,      starRatings,     this.range  );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "business_unit",
        offset: this.offset_insight,
      };
      this.loader_commenttable_data = true;
      await store.dispatch("getcommenttabledata", payload).then(() => {
        var commenttabledata = store.getters.getcommenttabledata;
        //console.log("commenttabledata::: ", commenttabledata);
        var count = 0;
        // if(commenttabledata.length > 0){
        // this.getstarrating_Count(starratingpiechartdata);
        // this.commenttable_data = commenttabledata;
        // this.commenttable_data_partner = commenttabledata;

        //console.log("commenttabledata ::: ", commenttabledata);
        if (commenttabledata.length > 0) {
          this.commenttable_data = [
            ...this.commenttable_data,
            ...commenttabledata,
          ];
          this.commenttable_data_partner = [
            ...this.commenttable_data_partner,
            ...commenttabledata,
          ];

          this.offset_insight += commenttabledata.length;
          var aa = commenttabledata.length - this.offset_insight;
          //console.log(   "this.offset_location",      aa,      this.offset_insight,     commenttabledata.length );
          if (aa == 0) {
            this.loadMore = false;
          } else {
            this.loadMore = true;
          }
        } else {
          this.commenttable_data = [];
          this.commenttable_data_partner = [];
        }
        this.loader_commenttable_data = false;
        return;
      });
    },
    async getreviewsvscommentovertime() {
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];

      var partner_ids = this.partner_ids;
      if (this.businessunitSelected.length > 0) {
        this.businessunitSelected.forEach((bu) => {
          business_unit_ids.push(bu);
        });
      }
      // if(this.locationSelected.length > 0){
      //   this.locationSelected.forEach((location) => {
      //     location_ids.push(location);
      //   });
      // }
      // //console.log("this.locationSelected , location_ids ::: ", this.locationSelected , location_ids);
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      //console.log( "selected ==>",  this.starratingSelected,   starRatings,    this.range   );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "business_unit",
      };
      this.loader_reviewsvscommentovertimedata = true;

      await store.dispatch("getreviewsvscommentovertime", payload).then(() => {
        var reviewsvscommentovertimedata =
          store.getters.getreviewsvscommentovertime;
        //console.log(   "reviewsvscommentovertimedata::: ",   reviewsvscommentovertimedata   );
        var count = 0;
        this.reviewsvscommentovertimedata_partner =
          reviewsvscommentovertimedata;

        if (reviewsvscommentovertimedata.length > 0) {
          this.getreviewsvscommentovertimedataMonth(
            reviewsvscommentovertimedata
          );
        } else {
          this.apexdata_label = [];
          this.apex_dataconfig_data2 = {
            dataSource: {
              chartOptions: {
                chart: {
                  type: "bar",
                  id: "basic-bar",
                },
              },
            },
          };
        }
        this.loader_reviewsvscommentovertimedata = false;

        return;
      });
    },
    async getavgstarratingperday() {
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];

      var partner_ids = this.partner_ids;

      if (this.businessunitSelected.length > 0) {
        this.businessunitSelected.forEach((bu) => {
          business_unit_ids.push(bu);
        });
      }
      // if(this.locationSelected.length > 0){
      //   this.locationSelected.forEach((location) => {
      //     location_ids.push(location);
      //   });
      // }
      // //console.log("this.locationSelected , location_ids ::: ", this.locationSelected , location_ids);
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      //console.log("selected ==>",   this.starratingSelected,    starRatings,    this.range   );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "business_unit",
      };
      this.loader_avgstarday = true;

      await store.dispatch("getavgstarratingperday", payload).then(() => {
        var avgstarratingperday = store.getters.getavgstarratingperday;
        //console.log("avgstarratingperday::: ", avgstarratingperday);
        var count = 0;
        // this.avgstarratingperday_partner=avgstarratingperday;

        if (avgstarratingperday.length > 0) {
          // this.getreviewsvscommentovertimedataMonth(avgstarratingperday);
          this.getreview_Countquarter(avgstarratingperday);
        } else {
          this.apexdata_label_days = [];
          this.apex_dataconfig_data3 = {
            dataSource: {
              chartOptions: {
                chart: {
                  type: "line",
                  id: "basic-bar",
                },
              },
            },
          };
        }
        this.loader_avgstarday = false;
        return;
      });
    },
    async getavgstarratingpermonth() {
      var partner_ids = [];
      var business_unit_ids = [];
      var location_ids = [];
      var starRatings = [];
      var create_date = [];

      var partner_ids = this.partner_ids;
      if (this.businessunitSelected.length > 0) {
        this.businessunitSelected.forEach((bu) => {
          business_unit_ids.push(bu);
        });
      }
      // if(this.locationSelected.length > 0){
      //   this.locationSelected.forEach((location) => {
      //     location_ids.push(location);
      //   });
      // }
      // //console.log("this.locationSelected , location_ids ::: ", this.locationSelected , location_ids);
      if (this.starratingSelected.length > 0) {
        this.starratingSelected.forEach((rating) => {
          starRatings.push(rating.value);
        });
      }

      //console.log(   "selected ==>",   this.starratingSelected,    starRatings,  this.range  );
      if (this.range[0] !== null && this.range.length > 0) {
        var start = moment(this.range[0]).format("YYYY-MM-DD");
        var end = moment(this.range[1]).format("YYYY-MM-DD");
        create_date.push(start);
        create_date.push(end);
      }

      var payload = {
        partner_ids: partner_ids,
        location_ids: location_ids,
        business_unit_ids: business_unit_ids,
        partner_ids: partner_ids,
        starRatings: starRatings,
        create_date: create_date,
        page_ref: "business_unit",
      };
      this.loader_avgstarmonth = true;

      await store.dispatch("getavgstarratingpermonth", payload).then(() => {
        var avgstarratingpermonth = store.getters.getavgstarratingpermonth;
        //console.log("avgstarratingpermonth::: ", avgstarratingpermonth);
        var count = 0;
        this.avgstarratingpermonth_partner = avgstarratingpermonth;
        if (avgstarratingpermonth.length > 0) {
          // this.getreviewsvscommentovertimedataMonth(avgstarratingperday);
          this.getreview_CountMonth(avgstarratingpermonth);
        } else {
          this.apexdata_label = [];
          this.apex_dataconfig_data = {
            dataSource: {
              chartOptions: {
                chart: {
                  type: "line",
                  id: "basic-bar",
                },
              },
            },
          };
        }
        this.loader_avgstarmonth = false;
        return;
      });
    },

    getreview_Count(review_data) {
      var count = 0;
      var prev_key = "";
      var sorted_review = _.sortBy(review_data, "starRating");
      // //console.log("sorted_review:::::::;", gbareview, sorted_review);
      const result_star_rating = [
        ...sorted_review
          .reduce((r, o) => {
            const key = o.starRating;
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                review_count: 0,
                comment_count: 0,
              });
            // ////console.log("key in score::::::::", key);
            // if(key !== false){
            if (prev_key !== key) {
              if (o.has_comment !== false) item.comment_count += o.__count;
              item.review_count += o.__count;
              prev_key = key;
            } else {
              if (o.comment !== false) item.comment_count += o.__count;
              item.review_count += o.__count;
            }

            return r.set(key, item);
          }, new Map())
          .values(),
      ];

      // this.topic_starrating_data=result_star_rating;
      // var result_star_rating1=[]
      // result_star_rating.forEach((rating)=>{
      //   if(rating.category_name !== false)
      //     result_star_rating1.push(rating);
      // })
      this.rating_count = result_star_rating;
      this.getuniqueRatings(result_star_rating);
      // //console.log("rating_count", this.rating_count);
      return;
    },
    getstarrating_Count(review_data) {
      var count = 0;
      var prev_key = "";
      var sorted_review = _.sortBy(review_data, "starRating");
      // //console.log("sorted_review:::::::;", gbareview, sorted_review);
      const result_star_rating = [
        ...sorted_review
          .reduce((r, o) => {
            const key = o.starRating;
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                review_count: 0,
                comment_count: 0,
              });
            // ////console.log("key in score::::::::", key);
            // if(key !== false){
            if (prev_key !== key) {
              if (o.has_comment !== false) item.comment_count += o.__count;
              item.review_count += o.__count;
              prev_key = key;
            } else {
              if (o.comment !== false) item.comment_count += o.__count;
              item.review_count += o.__count;
            }

            return r.set(key, item);
          }, new Map())
          .values(),
      ];

      // this.topic_starrating_data=result_star_rating;
      // var result_star_rating1=[]
      // result_star_rating.forEach((rating)=>{
      //   if(rating.category_name !== false)
      //     result_star_rating1.push(rating);
      // })
      this.rating_count_piechart = result_star_rating;
      // this.getuniqueRatings(result_star_rating);
      // //console.log("rating_count", this.rating_count);
      return;
    },
    getreviewsvscommentovertimedataMonth(reviewsvscommentovertimedata) {
      var prev_key = "";
      var months = [];
      const result_monthdata = [
        ...reviewsvscommentovertimedata
          .reduce((r, o) => {
            const key = o["createTime:month"];
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                comment_count: 0,
                review_count: 0,
                month: "",
              });
            if (prev_key !== key) {
              if (o.has_comment !== false) item.comment_count += o.__count;
              item.review_count += o.__count;

              prev_key = key;
              item.month = o["createTime:month"];
              months.push(o["createTime:month"]);
              // //console.log("key, item 1111::::::::", o["create_date:month"]);
            } else {
              if (o.has_comment !== false) item.comment_count += o.__count;
              item.review_count += o.__count;
            }

            return r.set(key, item);
          }, new Map())
          .values(),
      ];
      //console.log("result_monthdata 1111::::: ", months, result_monthdata);

      this.apexdata_label = months;
      this.apex_dataConfig2(result_monthdata);
      // this.apex_dataConfig(result_monthdata);

      return;
    },

    getreview_CountMonth(gbareview) {
      // //console.log("gbareview in getreview_CountMonth ::::", gbareview);
      // var endDate =
      //   typeof this.range !== "string" && this.range[1] !== null
      //     ? moment(this.range[1]).format("DD MMM YYYY")
      //     : moment().endOf("month").format("DD MMM YYYY");
      // var startDate =
      //   typeof this.range !== "string" && this.range[0] !== null
      //     ? moment(this.range[0]).format("DD MMM YYYY")
      //     : moment()
      //         .subtract(1, "year")
      //         .add(1, "month")
      //         .startOf("month")
      //         .format("DD MMM YYYY");
      // var months = [];
      // var currentDate = startDate;
      // while (moment(currentDate) < moment(endDate)) {
      //   months.push(moment(currentDate).format("MMM YYYY"));
      //   currentDate = moment(currentDate).add(1, "month").format("DD MMM YYYY");
      // }

      // var gbareview_sorted = _.sortBy(gbareview, "createTime");
      // var filtered_data = gbareview_sorted.filter((item) => {
      //   return (
      //     moment(item.createTime) >= moment(startDate) &&
      //     moment(item.createTime) < moment(endDate)
      //   );
      // });
      var months = [];
      var prev_key = "";
      const result_monthdata = [
        ...gbareview
          .reduce((r, o) => {
            const key = o["createTime:month"];
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                comment_count: 0,
                review_count: 0,
                sum_rating: 0,
                month: "",
                count: 0,
              });
            if (prev_key !== key) {
              if (o.starRating_avg !== 0)
                item.sum_rating = item.sum_rating + o.starRating_avg;
              prev_key = key;
              item.month = o["createTime:month"];
              months.push(o["createTime:month"]);
              item.count += 1;
            } else {
              if (o.starRating_avg !== 0)
                item.sum_rating = item.sum_rating + o.starRating_avg;
              item.count += 1;
            }

            return r.set(key, item);
          }, new Map())
          .values(),
      ];
      // //console.log("result_monthdata 1111::::: ", months ,result_monthdata);

      this.apexdata_label = months;
      // this.apex_dataConfig2(result_monthdata);
      this.apex_dataConfig(result_monthdata);

      return;
    },
    getreview_Countquarter(gbareview) {
      var days = [];
      var prev_key = "";
      const result_monthdata = [
        ...gbareview
          .reduce((r, o) => {
            const key = o["createTime:day"];
            const item =
              r.get(key) ||
              Object.assign({}, o, {
                review_count: 0,
                sum_rating: 0,
                day: "",
                count: 0,
              });
            // //console.log("key in score::::::::", key, o.starRating_avg , o.__count);
            if (prev_key !== key) {
              item.review_count += item.review_count + o.__count;
              if (o.starRating !== 0) item.sum_rating += o.starRating_avg;
              prev_key = key;
              item.day = o["createTime:day"];
              days.push(o["createTime:day"]);
              item.count += 1;
            } else {
              item.count += 1;
              item.review_count += item.review_count + o.__count;
              if (o.starRating !== 0) item.sum_rating += o.starRating_avg;
            }

            return r.set(key, item);
          }, new Map())
          .values(),
      ];

      this.apexdata_label_days = days;
      this.apexdata3(result_monthdata);
      // //console.log("result_monthdataaoex3 ::::: " ,result_monthdata);

      return;
    },

    async getBusinessUnits() {
      var businessUnits = [];
      var partner_ids = this.partner_ids;
      var options = [];

      await store.dispatch("getBusinessUnits", partner_ids).then(() => {
        businessUnits = store.getters.getBusinessUnits;
        //console.log("businessUnits :::: ", businessUnits);
        // var businessunits_sorted = _.sortBy(businessUnits, "name" );
        var businessUnitByPartner = [];

        var prev_key = "";
        var data = [];
        var data1 = [];
        businessUnits.map((bu) => {
          if (partner_ids.includes(bu.partner_id[0])) {
            businessUnitByPartner.push(bu);
            var custom_label =
              bu.name + " - " + bu.city + " - " + bu.description;

            var key = bu.partner_id[1];
            if (prev_key !== key) {
              // //console.log("@@@@@@@@@@@@@@2 main ", prev_key , key , data, custom_label);
              if (data.some((loc) => loc.label === bu.partner_id[1])) {
                //console.log("already_exists");
                var index1 = _.findIndex(data, { label: bu.partner_id[1] });
                data[index1].children.push({
                  id: bu.id,
                  label: custom_label,
                  isNew: true,
                });
              } else {
                //console.log("doesnot exists");
                data.push({
                  id: bu.partner_id[0],
                  label: bu.partner_id[1],
                  children: [
                    {
                      id: bu.id,
                      label: custom_label,
                      isNew: true,
                    },
                  ],
                });
              }
              //console.log("data ::: ", data);
              prev_key = key;
            } else {
              var index1 = _.findIndex(data, { label: bu.partner_id[1] });
              //console.log(      "!!!!!!!!!!1 ",      prev_key,     index1,    key,      data,      data[index1]    );

              data[index1].children.push({
                id: bu.id,
                label: custom_label,
                isNew: true,
              });
              //console.log(     data[index1].children,    key,  "data[index1].children",   custom_label    );
            }
          }
        });
        options.push(data);

        this.businessUnits = options;
      });

      //console.log("Business Unit after call", this.businessUnits);
    },
    async getPartners() {
      var partners = store.getters.getPartners;
      if (partners.length == 0) {
        this.isLoading = true;
        await store.dispatch("getPartners").then(() => {
          partners = store.getters.getPartners;
          this.partners = partners;
          this.partnersArray = partners;
          // this.partnerSelected.push(partners[0]);
          // this.getfilterPartner();

          ////console.log("partners ::::::::: ",this.partners);
          return;
        });
      } else {
        this.partners = partners;
        this.partnersArray = partners;

        ////console.log("partners ::::::::: ",partners);
        return;
      }
    },
    apex_dataConfig(result_monthdata) {
      var average_rating = [];
      var month_data = this.apexdata_label;
      var resultlength = result_monthdata.length;
      if (resultlength > 0) {
        month_data.forEach((month, index) => {
          result_monthdata.forEach((t) => {
            if (month_data[index] == t["createTime:month"]) {
              //console.log( "t.sum_rating / t.count :: ", t.sum_rating,    t.count,   t.sum_rating / t.count  );
              average_rating[index] =
                t.sum_rating === 0 ? 0 : t.sum_rating / t.count;
            }
          });
          // })
        });
      } else {
        //console.log("No data");
      }
      //console.log( "average_rating in apexdata config 2121 ::: ",average_rating );
      this.apex_dataconfig_data = {
        dataSource: {
          series: [
            {
              name: "Avg Rating",
              data: average_rating,
            },
          ],
          chartOptions: {
            chart: {
              type: "line",
              // id: "basic-bar",
            },
            xaxis: {
              categories: this.apexdata_label,
            },
            yaxis: {
              decimalsInFloat: 0,
            },
            colors: [
              "#5700ff",
              "#eeff41",
              "#3d3d3d",
              "#7c7c7c",
              "#b08fff",
              "#D3C5FF",
              "#FAFF99",
              "#CCCCCC",
            ],

            fill: {
              colors: [
                "#5700ff",
                "#eeff41",
                "#3d3d3d",
                "#7c7c7c",
                "#b08fff",
                "#D3C5FF",
                "#FAFF99",
                "#CCCCCC",
              ],
            },
            dataLabels: {
              style: {
                colors: [
                  "#5700ff",
                  "#eeff41",
                  "#3d3d3d",
                  "#7c7c7c",
                  "#b08fff",
                  "#D3C5FF",
                  "#FAFF99",
                  "#CCCCCC",
                ],
              },
            },
            markers: {
              colors: [
                "#5700ff",
                "#eeff41",
                "#3d3d3d",
                "#7c7c7c",
                "#b08fff",
                "#D3C5FF",
                "#FAFF99",
                "#CCCCCC",
              ],
            },
            // grid: {
            //     row: {
            //       colors: ['#5700ff','#eeff41','#3d3d3d','#7c7c7c','#b08fff','#D3C5FF','#FAFF99','#CCCCCC']
            //     },
            //     column: {
            //       colors: ['#5700ff','#eeff41','#3d3d3d','#7c7c7c','#b08fff','#D3C5FF','#FAFF99','#CCCCCC']
            //     }
            //   },
          },
        },
      };
    },
    apex_dataConfig1(review_data) {
      // let data = {
      //   ratings: [],
      //   comments: [],
      //   reviews: [],
      // };
      // for (let i = 0; i < 5; i++) {
      //   data.ratings.push(this.valueData[i].rating.toString());
      //   data.comments.push(this.valueData[i].comments.toString());
      //   data.reviews.push(this.valueData[i].reviews.toString());
      // }
      var data1 = this.rating_count;
      //console.log("data1:::::::::::", data1);
      var ratings = [];
      var comment_count = [];
      var review_count = [];
      data1.forEach((t) => {
        // //console.log("t:::::::::::", t);
        ratings.push(t.starRating);
        comment_count.push(t.comment_count);
        review_count.push(t.review_count);
      });
      // //console.log("rating, comment_count, review_count",ratings, comment_count, review_count);
      this.apex_dataconfig_data1 = {
        dataSource: {
          series: [
            {
              name: "reviews",
              // data: data.reviews,
              data: review_count,
            },
            {
              name: "comments",
              // data: data.comments,
              data: comment_count,
            },
          ],
          chartOptions: {
            chart: {
              type: "bar",
              id: "basic-bar",
            },
            xaxis: {
              categories: ratings,
            },
            colors: [
              "#eeff41",
              "#3d3d3d",
              "#5700ff",
              "#7c7c7c",
              "#b08fff",
              "#D3C5FF",
              "#FAFF99",
              "#CCCCCC",
            ],

            fill: {
              colors: [
                "#eeff41",
                "#3d3d3d",
                "#5700ff",
                "#7c7c7c",
                "#b08fff",
                "#D3C5FF",
                "#FAFF99",
                "#CCCCCC",
              ],
            },
            dataLabels: {
              style: {
                colors: [
                  "#eeff41",
                  "#3d3d3d",
                  "#5700ff",
                  "#7c7c7c",
                  "#b08fff",
                  "#D3C5FF",
                  "#FAFF99",
                  "#CCCCCC",
                ],
              },
            },
            markers: {
              colors: [
                "#eeff41",
                "#3d3d3d",
                "#5700ff",
                "#7c7c7c",
                "#b08fff",
                "#D3C5FF",
                "#FAFF99",
                "#CCCCCC",
              ],
            },
            // grid: {
            //     row: {
            //       colors: ['#5700ff','#eeff41','#3d3d3d','#7c7c7c','#b08fff','#D3C5FF','#FAFF99','#CCCCCC']
            //     },
            //     column: {
            //       colors: ['#5700ff','#eeff41','#3d3d3d','#7c7c7c','#b08fff','#D3C5FF','#FAFF99','#CCCCCC']
            //     }
            //   },
          },
        },
      };
    },
    apex_dataConfig2(result_monthdata) {
      let data = {
        time: [],
        comments: [],
        reviews: [],
      };
      // var comment_count = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      // var review_count = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      var comment_count = [];
      var review_count = [];
      var month_data = this.apexdata_label;

      month_data.forEach((month, index) => {
        result_monthdata.forEach((t) => {
          if (month_data[index] == t.month) {
            comment_count[index] = t.comment_count;
            review_count[index] = t.review_count;
          }
        });
      });
      this.apex_dataconfig_data2 = {
        dataSource: {
          series: [
            {
              name: "reviews",
              // data: data.reviews,
              data: review_count,
            },
            {
              name: "comments",
              data: comment_count,
            },
          ],
          chartOptions: {
            chart: {
              type: "bar",
              id: "basic-bar",
            },
            xaxis: {
              categories: this.apexdata_label,
            },
            colors: [
              "#eeff41",
              "#3d3d3d",
              "#5700ff",
              "#7c7c7c",
              "#b08fff",
              "#D3C5FF",
              "#FAFF99",
              "#CCCCCC",
            ],

            fill: {
              colors: [
                "#eeff41",
                "#3d3d3d",
                "#5700ff",
                "#7c7c7c",
                "#b08fff",
                "#D3C5FF",
                "#FAFF99",
                "#CCCCCC",
              ],
            },
            dataLabels: {
              style: {
                colors: [
                  "#eeff41",
                  "#3d3d3d",
                  "#5700ff",
                  "#7c7c7c",
                  "#b08fff",
                  "#D3C5FF",
                  "#FAFF99",
                  "#CCCCCC",
                ],
              },
            },
            markers: {
              colors: [
                "#eeff41",
                "#3d3d3d",
                "#5700ff",
                "#7c7c7c",
                "#b08fff",
                "#D3C5FF",
                "#FAFF99",
                "#CCCCCC",
              ],
            },
            // grid: {
            //     row: {
            //       colors: ['#5700ff','#eeff41','#3d3d3d','#7c7c7c','#b08fff','#D3C5FF','#FAFF99','#CCCCCC']
            //     },
            //     column: {
            //       colors: ['#5700ff','#eeff41','#3d3d3d','#7c7c7c','#b08fff','#D3C5FF','#FAFF99','#CCCCCC']
            //     }
            //   },
          },
        },
      };
    },
    apexdata3(result_monthdata) {
      var average_rating = [];
      var days_data = this.apexdata_label_days;
      days_data.forEach((day) => {
        average_rating.push(0);
      });
      // //console.log("days_data", days_data, result_monthdata);

      days_data.forEach((day, index) => {
        result_monthdata.forEach((t) => {
          // //console.log("t ::::::::::::::: ", t);
          if (days_data[index] == t["createTime:day"]) {
            // comment_count.push(t.comment_count);
            // review_count.push(t.review_count);
            // average_rating.push(t.sum_rating ===0 ? 0 :(t.sum_rating/t.review_count));
            average_rating[index] =
              t.sum_rating === 0 ? 0 : t.sum_rating / t.count;
          }
        });
      });
      //console.log("this.apexdata_label_days :: ", this.apexdata_label_days);
      //console.log("average_rating1111 :: ", average_rating);
      this.apex_dataconfig_data3 = {
        dataSource: {
          series: [
            {
              name: "Avg Rating",
              data: average_rating,
            },
          ],
          chartOptions: {
            chart: {
              type: "line",
              // id: "basic-bar",
            },
            xaxis: {
              categories: this.apexdata_label_days,
            },
            yaxis: {
              decimalsInFloat: 0,
            },
            colors: [
              "#5700ff",
              "#eeff41",
              "#3d3d3d",
              "#7c7c7c",
              "#b08fff",
              "#D3C5FF",
              "#FAFF99",
              "#CCCCCC",
            ],

            fill: {
              colors: [
                "#5700ff",
                "#eeff41",
                "#3d3d3d",
                "#7c7c7c",
                "#b08fff",
                "#D3C5FF",
                "#FAFF99",
                "#CCCCCC",
              ],
            },
            dataLabels: {
              style: {
                colors: [
                  "#5700ff",
                  "#eeff41",
                  "#3d3d3d",
                  "#7c7c7c",
                  "#b08fff",
                  "#D3C5FF",
                  "#FAFF99",
                  "#CCCCCC",
                ],
              },
            },
            markers: {
              colors: [
                "#5700ff",
                "#eeff41",
                "#3d3d3d",
                "#7c7c7c",
                "#b08fff",
                "#D3C5FF",
                "#FAFF99",
                "#CCCCCC",
              ],
            },
            // grid: {
            //     row: {
            //       colors: ['#5700ff','#eeff41','#3d3d3d','#7c7c7c','#b08fff','#D3C5FF','#FAFF99','#CCCCCC']
            //     },
            //     column: {
            //       colors: ['#5700ff','#eeff41','#3d3d3d','#7c7c7c','#b08fff','#D3C5FF','#FAFF99','#CCCCCC']
            //     }
            //   },
            //   yaxis: {
            //     categories: [0, 1, 2, 3],
            //   },
          },
        },
      };
    },
    // apex_dataConfig(result_monthdata) {
    //   var comment_count = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    //   var review_count = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    //   var average_rating = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    //   var month_data = this.apexdata_label;
    //   // //console.log("result_monthdata apex_dataConfig:::: ", result_monthdata, month_data.length, result_monthdata.length);
    //   var resultlength = result_monthdata.length;
    //   if (resultlength > 0) {
    //     month_data.forEach((month, index) => {
    //       // //console.log("month::::: ", month, index);
    //       result_monthdata.forEach((t) => {
    //         // //console.log("t.sum_rating ===0 ? 0 :(t.sum_rating/t.review_count", t.sum_rating ===0 ? 0 :(t.sum_rating/t.review_count));
    //         if (month_data[index] == t.month) {
    //           comment_count[index] = t.comment_count;
    //           review_count[index] = t.review_count;
    //           average_rating[index] =
    //             t.sum_rating === 0 ? 0 : t.sum_rating / t.review_count;
    //         }
    //       });
    //     });
    //   } else {
    //     //console.log("No data");
    //   }
    //   this.apex_dataconfig_data = {
    //     dataSource: {
    //       series: [
    //         {
    //           name: "Avg Rating",
    //           data: average_rating,
    //         },
    //       ],
    //       chartOptions: {
    //         chart: {
    //           type: "line",
    //           // id: "basic-bar",
    //         },
    //         xaxis: {
    //           categories: this.apexdata_label,
    //         },
    //         yaxis: {
    //           decimalsInFloat: 0,
    //         },
    //         //   yaxis: {
    //         //     categories: [0, 1, 2, 3],
    //         //   },
    //       },
    //     },
    //   };
    // },
    // apex_dataConfig1(gbareview) {
    //   // let data = {
    //   //   ratings: [],
    //   //   comments: [],
    //   //   reviews: [],
    //   // };
    //   // for (let i = 0; i < 5; i++) {
    //   //   data.ratings.push(this.valueData[i].rating.toString());
    //   //   data.comments.push(this.valueData[i].comments.toString());
    //   //   data.reviews.push(this.valueData[i].reviews.toString());
    //   // }
    //   var data1 = this.rating_count;
    //   // //console.log("data1:::::::::::", data1);
    //   var ratings = [];
    //   var comment_count = [];
    //   var review_count = [];
    //   data1.forEach((t) => {
    //     // //console.log("t:::::::::::", t);
    //     ratings.push(t.starRating);
    //     comment_count.push(t.comment_count);
    //     review_count.push(t.review_count);
    //   });
    //   // //console.log("rating, comment_count, review_count",ratings, comment_count, review_count);
    //   this.apex_dataconfig_data1 = {
    //     dataSource: {
    //       series: [
    //         {
    //           name: "reviews",
    //           // data: data.reviews,
    //           data: review_count,
    //         },
    //         {
    //           name: "comments",
    //           // data: data.comments,
    //           data: comment_count,
    //         },
    //       ],
    //       chartOptions: {
    //         chart: {
    //           type: "bar",
    //           id: "basic-bar",
    //         },
    //         xaxis: {
    //           categories: ratings,
    //         },
    //       },
    //     },
    //   };
    // },
    // apex_dataConfig2(result_monthdata) {
    //   let data = {
    //     time: [],
    //     comments: [],
    //     reviews: [],
    //   };
    //   var comment_count = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    //   var review_count = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    //   var month_data = this.apexdata_label;

    //   month_data.forEach((month, index) => {
    //     result_monthdata.forEach((t) => {
    //       if (month_data[index] == t.month) {
    //         comment_count[index] = t.comment_count;
    //         review_count[index] = t.review_count;
    //       }
    //     });
    //   });
    //   this.apex_dataconfig_data2 = {
    //     dataSource: {
    //       series: [
    //         {
    //           name: "reviews",
    //           // data: data.reviews,
    //           data: review_count,
    //         },
    //         {
    //           name: "comments",
    //           data: comment_count,
    //         },
    //       ],
    //       chartOptions: {
    //         chart: {
    //           type: "bar",
    //           id: "basic-bar",
    //         },
    //         xaxis: {
    //           categories: this.apexdata_label,
    //         },
    //       },
    //     },
    //   };
    // },
    // apexdata3(result_monthdata) {
    //   // var last60 = this.getLast60DaysData(this.global_gbaReviews);
    //   // let data = {
    //   //   time: [],
    //   //   ratings: [],
    //   // };
    //   // last60.forEach((a) => {
    //   //   var t = a.timestamp.slice(4);
    //   //   t = t.split(" ");
    //   //   t = t[0] + "," + t[1] + " " + t[2];
    //   //   // //console.log("time==>", t, " rating==>", a.data?.starRating);
    //   //   data.time.push(t);
    //   //   data.ratings.push(a.data?.starRating ? a.data?.starRating : 0);
    //   // });

    //   // for (let i = 0; i < this.global_yearlyReviews.length; i++) {
    //   //   for (let j = 0; j < 12; j++) {
    //   //     var time =
    //   //       this.getMonthName(j + 1) + " " + this.global_yearlyReviews[i].year;
    //   //     data.time.push(time);
    //   //     if (this.global_yearlyReviews[i][j + 1]) {
    //   //       const rating = this.getAverageRating(
    //   //         this.global_yearlyReviews[i][j + 1]
    //   //       );
    //   //       data.ratings.push(rating);
    //   //     } else {
    //   //       data.ratings.push(0);
    //   //     }
    //   //   }
    //   // }
    //   var average_rating = [];
    //   var days_data = this.apexdata_label_days;
    //   days_data.forEach((day) => {
    //     average_rating.push(0);
    //   });
    //   // //console.log("days_data", days_data, result_monthdata);

    //   days_data.forEach((day, index) => {
    //     result_monthdata.forEach((t) => {
    //       // //console.log("t ::::::::::::::: ", t);
    //       if (days_data[index] == t.day) {
    //         // comment_count.push(t.comment_count);
    //         // review_count.push(t.review_count);
    //         // average_rating.push(t.sum_rating ===0 ? 0 :(t.sum_rating/t.review_count));
    //         average_rating[index] =
    //           t.sum_rating === 0 ? 0 : t.sum_rating / t.review_count;
    //       }
    //     });
    //   });
    //   this.apex_dataconfig_data3 = {
    //     dataSource: {
    //       series: [
    //         {
    //           name: "Avg Rating",
    //           data: average_rating,
    //         },
    //       ],
    //       chartOptions: {
    //         chart: {
    //           type: "line",
    //           // id: "basic-bar",
    //         },
    //         xaxis: {
    //           categories: this.apexdata_label_days,
    //         },
    //         yaxis: {
    //           decimalsInFloat: 0,
    //         },
    //         //   yaxis: {
    //         //     categories: [0, 1, 2, 3],
    //         //   },
    //       },
    //     },
    //   };
    // },
    color(value) {
      let $color;
      if (value <= 25) {
        $color = "info";
      } else if (value > 25 && value <= 50) {
        $color = "success";
      } else if (value > 50 && value <= 75) {
        $color = "warning";
      } else if (value > 75 && value <= 100) {
        $color = "danger";
      }
      return $color;
    },
    getAverageRating(reviews) {
      var rating = 0;
      reviews.forEach((r) => {
        rating += r.starRating;
      });
      return rating / reviews.length;
    },
    async getGbaReviews() {
      var array = [];
      var gbareview = [];
      this.isLoading = true;
      var partner_ids = this.partner_ids;
      store.dispatch("getGbaReviewsTP", partner_ids).then(() => {
        gbareview = store.getters.getGbaReviewsTP;
        // //console.log("gbareview ::::::::::::: ", gbareview);
        this.global_gbaReviews = gbareview;
        this.global_gbaReviewsArray = gbareview;
        this.getreview_Countweek(gbareview);
        this.getreview_Count_month(gbareview);
        this.getreview_Count(gbareview);
        this.apex_dataConfig1(gbareview);
        this.getreview_CountMonth(gbareview);
        this.getreview_Countquarter(gbareview);
        // shuffleArray([gbareview]);
        this.isLoading = false;
      });
    },
    getuniqueRatings(starRatings) {
      // //console.log("getuniqueRatings", starRatings);
      var unique_rating = [];
      starRatings.forEach((rating) => {
        unique_rating.push({
          label: rating.starRating,
          value: rating.starRating,
        });
      });
      // //console.log("unique_rating::::::::", unique_rating);

      // this.starRating_unique = unique_rating;

      // this.starRatings = _.sortBy( starRatingunique, 'name' );
    },
    // getreview_Count(gbareview) {
    //   var count = 0;
    //   var prev_key = "";
    //   var sorted_review = _.sortBy(gbareview, "starRating");
    //   // //console.log("sorted_review:::::::;", gbareview, sorted_review);
    //   const result_star_rating = [
    //     ...sorted_review
    //       .reduce((r, o) => {
    //         const key = o.starRating;
    //         const item =
    //           r.get(key) ||
    //           Object.assign({}, o, {
    //             review_count: 0,
    //             comment_count: 0,
    //             // instances: 0
    //           });
    //         // ////console.log("key in score::::::::", key);
    //         // if(key !== false){
    //         if (prev_key !== key) {
    //           if (o.comment !== false) item.comment_count += 1;
    //           item.review_count += 1;
    //           prev_key = key;
    //         } else {
    //           if (o.comment !== false)
    //             item.comment_count += 1;
    //           item.review_count += 1;
    //         }

    //         return r.set(key, item);
    //       }, new Map())
    //       .values(),
    //   ];

    //   // this.topic_starrating_data=result_star_rating;
    //   // var result_star_rating1=[]
    //   // result_star_rating.forEach((rating)=>{
    //   //   if(rating.category_name !== false)
    //   //     result_star_rating1.push(rating);
    //   // })
    //   this.rating_count = result_star_rating;
    //   this.getuniqueRatings(result_star_rating);
    //   //console.log("rating_count", this.rating_count);
    //   return;
    // },
    // getreview_CountMonth(gbareview) {
    //   // //console.log("gbareview in getreview_CountMonth ::::", gbareview);
    //   var endDate =
    //     typeof this.range !== "string" && this.range[1] !== null
    //       ? moment(this.range[1]).format("DD MMM YYYY")
    //       : moment().endOf("month").format("DD MMM YYYY");
    //   var startDate =
    //     typeof this.range !== "string" && this.range[0] !== null
    //       ? moment(this.range[0]).format("DD MMM YYYY")
    //       : moment()
    //           .subtract(1, "year")
    //           .add(1, "month")
    //           .startOf("month")
    //           .format("DD MMM YYYY");
    //   var months = [];
    //   var currentDate = startDate;
    //   while (moment(currentDate) < moment(endDate)) {
    //     months.push(moment(currentDate).format("MMM YYYY"));
    //     currentDate = moment(currentDate).add(1, "month").format("DD MMM YYYY");
    //   }

    //   var gbareview_sorted = _.sortBy(gbareview, "createTime");
    //   var filtered_data = gbareview_sorted.filter((item) => {
    //     return (
    //       moment(item.createTime) >= moment(startDate) &&
    //       moment(item.createTime) < moment(endDate)
    //     );
    //   });

    //   var prev_key = "";
    //   const result_monthdata = [
    //     ...filtered_data
    //       .reduce((r, o) => {
    //         const key = moment(o.createTime).format("MMM YYYY");
    //         const item =
    //           r.get(key) ||
    //           Object.assign({}, o, {
    //             comment_count: 0,
    //             review_count: 0,
    //             sum_rating: 0,
    //             month: "",
    //           });
    //         if (prev_key !== key) {
    //           if (o.comment !== false) item.comment_count += 1;
    //           item.review_count += 1;
    //           if (o.starRating !== 0)
    //             item.sum_rating = item.sum_rating + o.starRating;
    //           prev_key = key;
    //           item.month = moment(o.createTime).format("MMM YYYY");
    //           // //console.log("key, item 1111::::::::", item.sum_rating ,item.review_count, key , o.starRating ,item.sum_rating);
    //         } else
    //           {
    //             if (o.comment !== false) item.comment_count += 1;
    //             item.review_count += 1;
    //             if (o.starRating !== 0)
    //               item.sum_rating = item.sum_rating + o.starRating;
    //           }

    //         // //console.log("key, item 1111",o.starRating, item.review_count,item.sum_rating, key);//, item, item.month

    //         return r.set(key, item);
    //       }, new Map())
    //       .values(),
    //   ];
    //   // //console.log("result_monthdata 1111::::: ", months ,result_monthdata);

    //   this.apexdata_label = months;
    //   this.apex_dataConfig2(result_monthdata);
    //   this.apex_dataConfig(result_monthdata);

    //   return;
    // },
    // getreview_Countquarter(gbareview) {
    //   // //console.log("gbareview in getreview_Countquarter ::::", gbareview);
    //   var endDate =
    //     typeof this.range !== "string" && this.range[1] !== null
    //       ? moment(this.range[1]).format("DD MMM YYYY")
    //       : moment().format("DD MMM YYYY");
    //   var startDate =
    //     typeof this.range !== "string" && this.range[0] !== null
    //       ? moment(this.range[0]).format("DD MMM YYYY")
    //       : moment().subtract(60, "days").format("DD MMM YYYY");
    //   var days = [];
    //   var currentDate = startDate;
    //   while (moment(currentDate) < moment(endDate)) {
    //     days.push(moment(currentDate).format("DD MMM YYYY"));
    //     currentDate = moment(currentDate).add(1, "days").format("DD MMM YYYY");
    //   }
    //   // //console.log("days :::: ", days);

    //   // gbareview.sort((a, b) => a.diff(b));
    //   gbareview.sort(function (a, b) {
    //     // Turn your strings into dates, and then subtract them
    //     // to get a value that is either negative, positive, or zero.
    //     return new Date(b.date) - new Date(a.date);
    //   });
    //   // //console.log("gbareview before filter", gbareview);

    //   // gbareview.reverse()
    //   // var gbareview_sorted = _.sortBy( gbareview, 'createTime' );
    //   var filtered_data = gbareview.filter((item) => {
    //     // //console.log("item.createTime", item.createTime);
    //     // //console.log("moment(item.createTime) >= moment(startDate) moment(item.createTime) < moment(endDate) ",moment(item.createTime) >= moment(startDate) , moment(item.createTime) < moment(endDate));
    //     return (
    //       moment(item.createTime) >= moment(startDate) &&
    //       moment(item.createTime) < moment(endDate)
    //     );
    //   });
    //   // //console.log("filtered_data quarter :::: ", filtered_data);

    //   var prev_key = "";
    //   const result_monthdata = [
    //     ...filtered_data
    //       .reduce((r, o) => {
    //         const key = moment(o.createTime).format("DD MMM YYYY");
    //         const item =
    //           r.get(key) ||
    //           Object.assign({}, o, {
    //             comment_count: 0,
    //             review_count: 0,
    //             sum_rating: 0,
    //             day: "",
    //           });
    //         // //console.log("key in score::::::::", key);
    //         if (prev_key !== key) {
    //           if (o.comment !== false) item.comment_count += 1;
    //           item.review_count += 1;
    //           if (o.starRating !== 0) item.sum_rating += o.starRating;
    //           prev_key = key;
    //           item.day = moment(o.createTime).format("DD MMM YYYY");
    //         } else if (o.comment !== false) item.comment_count += 1;
    //         item.review_count += 1;
    //         if (o.starRating !== 0) item.sum_rating += o.starRating;

    //         // //console.log("key, item apex3", key, item, item.month)

    //         return r.set(key, item);
    //       }, new Map())
    //       .values(),
    //   ];

    //   this.apexdata_label_days = days;

    //   this.apexdata3(result_monthdata);
    //   // //console.log("result_monthdataaoex3 ::::: " ,result_monthdata);

    //   return;
    // },
    // getreview_Countweek(gbareview) {
    //   // //console.log("gbareview in getreview_CountMonth ::::", gbareview);
    //   var endDate = moment("2020-03-01").format("DD MMM YYYY");
    //   var startDate = moment("2020-03-01")
    //     .subtract(7, "days")
    //     .format("DD MMM YYYY");
    //   var months = [];
    //   var currentDate = startDate;
    //   // while (moment(currentDate) < moment(endDate)) {
    //   //     months.push( moment(currentDate).format('MMM YYYY') );
    //   //     currentDate = moment(currentDate).add(1, 'month').format('DD MMM YYYY') ;
    //   // }

    //   var gbareview_sorted = _.sortBy(gbareview, "createTime");
    //   // //console.log("gbareview_sorted======== start and end", gbareview_sorted.length, startDate, endDate);
    //   var filtered_data = gbareview_sorted.filter((item) => {
    //     return (
    //       moment(item.createTime) >= moment(startDate) &&
    //       moment(item.createTime) < moment(endDate)
    //     );
    //   });
    //   // //console.log("filtered_data", filtered_data.length);

    //   var prev_key = "";
    //   const result_monthdata = [
    //     ...filtered_data
    //       .reduce((r, o) => {
    //         const key = moment(o.createTime).format("DD MMM YYYY");
    //         const item =
    //           r.get(key) ||
    //           Object.assign({}, o, {
    //             comment_count: 0,
    //             review_count: 0,
    //             sum_rating: 0,
    //             month: "",
    //           });
    //         if (prev_key !== key) {
    //           if (o.comment !== false) item.comment_count += 1;
    //           item.review_count += 1;
    //           if (o.starRating !== 0)
    //             item.sum_rating = item.sum_rating + o.starRating;
    //           prev_key = key;
    //           item.month = moment(o.createTime).format("MMM YYYY");
    //           // //console.log("key, @@@item 1111::::::::", item.sum_rating ,item.review_count, key , o.starRating ,item.sum_rating);
    //         } else if (o.comment !== false) item.comment_count += 1;
    //         item.review_count += 1;
    //         if (o.starRating !== 0)
    //           item.sum_rating = item.sum_rating + o.starRating;

    //         // //console.log("key, item 1111",o.starRating, item.review_count,item.sum_rating, key);//, item, item.month

    //         return r.set(key, item);
    //       }, new Map())
    //       .values(),
    //   ];
    //   // //console.log("weekdata 1111::::: ",result_monthdata, result_monthdata[0].review_count, result_monthdata[0].comment_count,result_monthdata[0].sum_rating,  result_monthdata[0].sum_rating / result_monthdata[0].review_count);

    //   this.widget_weekdata = result_monthdata;
    //   var weekdata_rating = [];
    //   var weekdata_comment = [];
    //   var weekdata_reviews = [];
    //   var sum_rating = 0;
    //   var sum_reviews = 0;
    //   var sum_comment = 0;

    //   result_monthdata.forEach((week) => {
    //     // //console.log("WEeek data:", week);
    //     sum_rating += week.sum_rating;
    //     sum_reviews += week.review_count;
    //     sum_comment += week.comment_count;

    //     weekdata_rating.push(week.sum_rating);
    //     weekdata_comment.push(week.comment_count);
    //     weekdata_reviews.push(week.review_count);
    //   });
    //   // //console.log("weekdata", weekdata_rating);
    //   // //console.log("weekdata", weekdata_comment);
    //   // //console.log("weekdata_reviews", weekdata_reviews);
    //   this.widget_weekdata_rating = weekdata_rating;
    //   this.widget_weekdata_comment = weekdata_comment;
    //   this.widget_weekdata_review = weekdata_reviews;
    //   this.widget_reviews = sum_reviews;
    //   this.widget_comments = sum_comment;
    //   //console.log("sum_rating , sum_reviews ", sum_rating , sum_reviews);
    //   if(sum_reviews > 0){
    //     this.widget_rating = Number(sum_rating / sum_reviews).toFixed(2);
    //   }
    //   else{
    //     this.widget_rating=0
    //   }
    //   return;
    // },
    // getreview_Count_month(gbareview) {
    //   // //console.log("gbareview in getreview_CountMonth ::::", gbareview);
    //   var endDate = moment().format("DD MMM YYYY");
    //   var startDate = moment().subtract(1, "year").format("DD MMM YYYY");
    //   var months = [];
    //   var currentDate = startDate;
    //   while (moment(currentDate) < moment(endDate)) {
    //     months.push(moment(currentDate).format("MMM YYYY"));
    //     currentDate = moment(currentDate).add(1, "month").format("DD MMM YYYY");
    //   }

    //   var gbareview_sorted = _.sortBy(gbareview, "createTime");
    //   // //console.log("gbareview_sorted=mnth======= start and end", gbareview_sorted.length, startDate, endDate);
    //   var filtered_data = gbareview_sorted.filter((item) => {
    //     return (
    //       moment(item.createTime) >= moment(startDate) &&
    //       moment(item.createTime) < moment(endDate)
    //     );
    //   });
    //   // //console.log("filtered_data mont=======", filtered_data.length);

    //   var prev_key = "";
    //   const result_monthdata = [
    //     ...filtered_data
    //       .reduce((r, o) => {
    //         const key = moment(o.createTime).format("MMM YYYY");
    //         const item =
    //           r.get(key) ||
    //           Object.assign({}, o, {
    //             comment_count: 0,
    //             review_count: 0,
    //             sum_rating: 0,
    //             month: "",
    //           });
    //         if (prev_key !== key) {
    //           if (o.comment !== false) item.comment_count += 1;
    //           item.review_count += 1;
    //           if (o.starRating !== 0)
    //             item.sum_rating = item.sum_rating + o.starRating;
    //           prev_key = key;
    //           item.month = moment(o.createTime).format("MMM YYYY");
    //           // //console.log("key, item 1111::::::::", item.sum_rating ,item.review_count, key , o.starRating ,item.sum_rating);
    //         } else if (o.comment !== false) item.comment_count += 1;
    //         item.review_count += 1;
    //         if (o.starRating !== 0)
    //           item.sum_rating = item.sum_rating + o.starRating;

    //         // //console.log("key, item 1111",o.starRating, item.review_count,item.sum_rating, key);//, item, item.month

    //         return r.set(key, item);
    //       }, new Map())
    //       .values(),
    //   ];
    //   // //console.log("result_monthdata 222::::: ", months ,result_monthdata);

    //   this.widget_month_data = result_monthdata;
    //   var widget_month_data = [];
    //   var total_review_count = 0;
    //   var total_rating = 0;
    //   months.forEach((month, index) => {
    //     result_monthdata.forEach((t) => {
    //       // //console.log("===========",month,t);
    //       if (months[index] == t.month) {
    //         widget_month_data[index] =
    //           t.sum_rating === 0
    //             ? 0
    //             : (t.sum_rating / t.review_count).toFixed(2);
    //       }
    //       total_review_count += t.review_count;
    //       total_rating += t.sum_rating;
    //       // total_review_count += months.
    //       // month_data.push(month);
    //     });
    //   });

    //   // //console.log("result_monthdata.sum_rating , result_monthdata.review_count", result_monthdata.sum_rating , result_monthdata.review_count);
    //   this.widget_monthlyRating = (total_rating / total_review_count).toFixed(
    //     2
    //   );
    //   this.widget_month_data = widget_month_data;
    //   this.labelbar = months;

    //   return;
    // },
  },
  watch: {
    partnerSelected: function (partnerSelected) {
      var partner_ids = [];
      //console.log("partner_ids::::", partnerSelected);
      // partnerSelected.forEach((partner) => {
      // partner_ids.push(partner.id);
      // });
      if (partnerSelected !== null) {
        partner_ids.push(partnerSelected.id);
      }
      //console.log("partner_ids::::", partnerSelected, partner_ids);

      if (partner_ids.length > 0) {
        // partner_ids = partner_ids;
        this.partner_ids = partner_ids;
        this.getBusinessUnits();

        this.get7daysavgRating();
        this.get7dayscomments();
        this.get7monthsavgRating();
        this.getreviewsandcommentgraphdata();
        this.getstarratingpiechartdata();
        this.getcommenttabledata();
        this.getreviewsvscommentovertime();
        this.getavgstarratingperday();
        this.getavgstarratingpermonth();
      } else {
        this.businessunitSelected = [];
        this.businessUnits = [[]];
        this.offset_insight = 0;
        this.widget_rating = 0;
        this.widget_comment = 0;
        this.widget_review = 0;
        this.widget_month_rating = 0;
        this.rating_count = [];
        this.rating_count_piechart = [];
        this.starRating_unique = [];
        this.commenttable_data = [];
        this.commenttable_data_partner = [];

        this.apex_dataconfig_data = {
          dataSource: {
            chartOptions: {
              chart: {
                type: "line",
                id: "basic-bar",
              },
            },
          },
        };
        this.apex_dataconfig_data1 = {
          dataSource: {
            chartOptions: {
              chart: {
                type: "bar",
                id: "basic-bar",
              },
            },
          },
        };
        this.apex_dataconfig_data2 = {
          dataSource: {
            chartOptions: {
              chart: {
                type: "bar",
                id: "basic-bar",
              },
            },
          },
        };
        this.apex_dataconfig_data3 = {
          dataSource: {
            chartOptions: {
              chart: {
                type: "line",
                id: "basic-bar",
              },
            },
          },
        };
        this.locations = [];
        this.locations1 = [[]];
        this.locationsArray = [];
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.barchart {
  height: 1000;
  width: 1000;
}

.gridstyle .col-md-4 {
  display: grid;
}
</style>
